export default "__VITE_ASSET__BcHQ_4AB__"